var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRevendaCinza(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.479,
    height: 41.382,
    viewBox: "0 0 47.479 41.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:gray;}.b,.f{fill:#fff;}.c,.d{stroke:#fff;stroke-width:1.5px;}.c{stroke-linecap:round;stroke-linejoin:round;}.d{fill:none;}.e,.f{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1187.133 -1907.618)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1191.006 1923)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 36.56842041015625 25.25 L 3.428292036056519 25.25 C 1.951482057571411 25.25 0.7500020265579224 24.24065017700195 0.7500020265579224 23 L 0.7500020265579224 3 C 0.7500020265579224 1.759349942207336 1.951482057571411 0.75 3.428292036056519 0.75 L 36.56842041015625 0.75 C 38.04523086547852 0.75 39.24670028686523 1.759349942207336 39.24670028686523 3 L 39.24670028686523 23 C 39.24670028686523 24.24065017700195 38.04523086547852 25.25 36.56842041015625 25.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 3.42828369140625 1.5 C 2.383041381835938 1.5 1.500003814697266 2.186920166015625 1.500003814697266 3 L 1.500003814697266 23 C 1.500003814697266 23.81307983398438 2.383041381835938 24.5 3.42828369140625 24.5 L 36.56841278076172 24.5 C 37.61365127563477 24.5 38.49670028686523 23.81307983398438 38.49670028686523 23 L 38.49670028686523 3 C 38.49670028686523 2.186920166015625 37.61365127563477 1.5 36.56841278076172 1.5 L 3.42828369140625 1.5 M 3.42828369140625 0 L 36.56841278076172 0 C 38.4618034362793 0 39.99670028686523 1.3431396484375 39.99670028686523 3 L 39.99670028686523 23 C 39.99670028686523 24.65685081481934 38.4618034362793 26 36.56841278076172 26 L 3.42828369140625 26 C 1.534893035888672 26 3.814697265625e-06 24.65685081481934 3.814697265625e-06 23 L 3.814697265625e-06 3 C 3.814697265625e-06 1.3431396484375 1.534893035888672 0 3.42828369140625 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1198.968 1930)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10,
    height: 16,
    rx: 1,
    transform: "translate(0.032)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(14.032)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.126-.764H39.433l7.428,13.632H.883Z",
    transform: "translate(1245 1909.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.664,0c5.03-.028,5.6,5.853,5.6,5.853H0S.634.028,5.664,0Z",
    transform: "translate(1257.268 1928) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.664,0c5.03-.028,5.6,5.853,5.6,5.853H0S.634.028,5.664,0Z",
    transform: "translate(1268.799 1928) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.664,0c5.03-.028,5.6,5.853,5.6,5.853H0S.634.028,5.664,0Z",
    transform: "translate(1280.331 1928) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.664,0c5.03-.028,5.6,5.853,5.6,5.853H0S.634.028,5.664,0Z",
    transform: "translate(1291.862 1928) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    y1: 14,
    x2: 3,
    transform: "translate(1257.5 1908.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    y1: 13,
    transform: "translate(1268.5 1908.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 4,
    y1: 14,
    transform: "translate(1276.5 1908.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRevendaCinza);
export default __webpack_public_path__ + "static/media/ic_revenda-cinza.3000d2a402c7945e6c70c8c6201305cc.svg";
export { ForwardRef as ReactComponent };